import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  IconButton,
  Typography,
  Box,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";

import useAdjustTransaction from "../../../hooks/useAdjustTransaction";
import SFDialogTitle from "../../../components/SFDialogTitle";
import useSFAlert from "../../../hooks/useSFAlert";
import { useTranslate } from "react-admin";
import settings from "../../../utils/settings";
/**
 * 10:18 AuanSar สมมุติ ของเดิม ได้แต้ม มา 50
10:18 AuanSar ปรากฏว่า คำนวนผิด ต้องได้ 100
10:19 AuanSar ก้ส่งแอดจัด มา 100
10:19 AuanSar มันจะไปเพิ่ม อีก 50 ให้คับ...
10:19 AuanSar ง่ายๆ คือ ส่งค่า ที่มันควรจะได้ ... แต่ไม่ใช่ค่า ที่มันควรจะเพิ่ม
 */

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    // height: 508,
    margin: "0 auto",
    paddingTop: 50,
  },
  newPointContainer: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    justifyItems: "start",
    width: "100%",
    alignItems: "center",
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  dialogpaper: {
    margin: 0,
    width: 667,
    // height: 508,
    maxWidth: 667,
    // maxHeight: 508,
    borderRadius:12
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 39,
    boxSizing: "border-box",
  },
  alignLeft: {
    alignSelf: "flex-start",
  },
  authorizeTextField: {
    width: 396,
    height: 66,
  },

  dialogAction: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    margin: "0 !important",
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "0 !important",
    borderRadius: "0px 0px 12px 12px",
  },
  remark: {
    width: "100%",
    fontSize: 20,
  },
}));

const AdjustDialog = ({
  open,
  onClose,
  transactionNo,
  memberId,
  existingPoint = 0,
  version,
}) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [pin, setPin] = useState();
  const [amount, setAmount] = useState(0);
  const [remark, setRemark] = useState();
  const { adjustTransaction } = useAdjustTransaction();
  const [alert] = useSFAlert();
  const translate = useTranslate();
  const { branchName } = settings();
  if (version === null) {
    alert("Missing transaction version");
    return null;
  }
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="adjust-dialog-title"
      open={open}
      classes={{
        root: classes.allContainer,
        paper: classes.dialogpaper,
      }}
    >
      <SFDialogTitle
        id="adjustsf-dialog-title"
        onClose={onClose}
        title="Adjust transaction"
      />

      <DialogContent classes={{ root: classes.dialogContent }}>
        <Box className={classes.newPointContainer}>
          <Typography align="center">Existing points</Typography>
          <Typography align="left" className={classes.alignLeft}>
            New points
          </Typography>
          <Typography align="center" variant="h5">
            {existingPoint}
          </Typography>
          <TextField
            type="number"
            value={amount}
            onFocus={(event) => event.target.select()}
            variant="outlined"
            onChange={(e) => setAmount(e.target.value)}
            className={classes.alignLeft}
            classes={{ multiline: classes.remarkMultiline }}
          />
        </Box>
        <Typography align="left" className={classes.alignLeft}>
          Remark
        </Typography>
        <TextField
          value={remark}
          variant="outlined"
          multiline
          rows={3}
          rowsMax={3}
          onChange={(e) => setRemark(e.target.value)}
          className={classes.remark}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <TextField
          type={showPassword ? "text" : "password"}
          label="Authorization code"
          classes={{ root: classes.authorizeTextField }}
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          disabled={
            !pin ||
            Number(amount) === Number(existingPoint) ||
            branchName === "All"
          }
          onClick={async () => {
            const result = await adjustTransaction({
              transactionNo: transactionNo,
              pin: pin,
              memberId: memberId,
              amount: amount,
              remark: remark,
              version: version,
            });

            if (result.error) {
              if (Array.isArray(result.message)) {
                return alert(
                  result.message[0].instancePath +
                    " " +
                    result.message[0].message
                );
              } else return alert(translate("ra.text.wrongAuthorizeCode"));
            }
            if (result) {
              onClose();
              return window.location.reload();
            }
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdjustDialog;
